import React, { useEffect, useState } from "react";
import { useLocation, NavLink, Outlet, useParams } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion/dist/framer-motion"
import motionConf from "../_motionConf";
import Projet from "./Projet";
import Loader from "../partials/Loader";
import _404_ from "./404";
import { useLastLocation } from "react-router-dom-last-location";

export default function ArchiveProjet() {
  const lastLocation = useLastLocation();
  const location = useLocation();
  const [isLoading, setLoading] = useState(true);
  const [projets, setProjets] = useState();
  const [projectId, setProjectId] = useState(0);
  const [init, setInit] = useState(false);
  const [projectScroll, setProjectScroll] = useState(false);
  const [nextProjet, setNextProjet] = useState({});


  // Get requested ID
  const params = useParams()["*"];

  // Manage navigation to single project
  // With additional child datas
  useEffect(() => {

    // Select Single Content based on param
    const path = params.match(/[\d]+/);
    if (!path || !path[0]) {
      setProjectId(false)
    }
    else {
      setProjectId(parseInt(path[0]));
    }

    // Avoid replay on language selection
    if (!init) setInit(true);

  }, [params])

  useEffect(() => {
    console.log(projectId)
  }, [projectId])

  // Load projects
  useEffect(() => {
    let _lang = location.hash ? location.hash.replace("#", "").toLocaleLowerCase() : 'fr';
    const fetchProjets = async () => {
      const data = await fetch(`https://bigl-architectes.fr/wp-json/wp/v2/project?lang=${_lang}`);
      const _projets = await data.json();

      /* Next ID calculation */
      // store all ids in array
      let _projetIds = _projets.map(projet => projet.id);
      // remove first element
      let offsetId = _projetIds.shift();
      // add it at the end
      _projetIds.push(offsetId);
      // and re-associate
      _projetIds.forEach((v, i) => {
        _projets[i].nextId = v
      });

      // Images preload
      for (const projet of _projets) {
        const img = new Image();
        img.src = projet.featured_image_url;
      }
      setProjectScroll(0);
      setProjets(_projets);
      // setLoading(false);

    }
    fetchProjets().catch(console.error);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    setLoading(!projets);
  }, [projets])


  // get link to project
  const childLink = (id) => {
    return `${id}${location.hash}`;
  }

  const getNextPost = (id) => {
    let currentIndex = projets.findIndex(o => o.id === id);
    let nextIndex = currentIndex === projets.length - 1 ? 0 : currentIndex + 1
    return projets[nextIndex]
  }

  const handleScroll = (event) => {
    setProjectScroll(event.target.scrollTop)
  }


  // No project (in selected language)
  if (!isLoading && projets.length === 0) return (<_404_ />)

  /* Transistions in ../_motionConf.js */
  // return (isLoading ? (
  //   <Loader />
  // ) : (
  return (!isLoading && projets && (
    <>
      <motion.div
        id="archive-project"
        key="archive-project"
        initial={{ x: '100vw' }}
        animate={{ x: 0 }}
        exit={{ x: '100vw' }}
        transition={motionConf.transition}
        onScroll={handleScroll}
        className={ projectId ? `no-scroll-y` : `` }
      >
        {projets?.map((projet) => projet && (
          <div id={`container-${projet.id}`} key={`container-${projet.id}`} className="archive-project-container" >

            {/* Archive Feat  - `archiveFeatured` */}
            <div className={`archive-featured`}>
              <NavLink to={childLink(projet.id)} state={{ nextId: projet.nextId }} key={`link-img-${projet.id}`} >
                <img
                  key={projet.featured_img}
                  src={projet.featured_image_url}
                  alt={projet.featured_img_caption || null}
                />
              </NavLink>
            </div>

            {/* Archive Title */}
            <h2 key={`title-${projet.id}`} className={projectId && projectId === projet.id ? 'active' : ''}>
              <NavLink to={childLink(projet.id)} state={{ nextId: projet.nextId }} className='post-title' key={`link-title-${projet.id}`} >
                {projet?.title?.rendered}
              </NavLink>
            </h2>

          </div>
        ))}

        {/* Single Project */}
        <AnimatePresence>
          {projectId &&
            <motion.div
              id={`project`}
              key={`single-project-${projectId}`}
              initial={{ x: '100vw', y: projectScroll }}
              animate={{ x: 0, y: projectScroll }}
              exit={{ x: '100vw', y: projectScroll }}
              transition={motionConf.transition}
            >
              <Projet id={projectId} nextProjet={getNextPost(projectId)} />
            </motion.div>
          }
        </AnimatePresence>

      </motion.div>
    </>
  )
  )
}
